import { Box } from "./MuiGenerals";

type Props = { count: number; showOriginalCount?: boolean };

export function PendingCount(props: Props) {
  const { count, showOriginalCount } = props;
  if (!count || count <= 0) return null;

  const getCount = () => {
    if (showOriginalCount) {
      return count;
    }
    return count > 99 ? "99+" : count;
  };

  return (
    <Box
      sx={{
        backgroundColor: "secondary.main",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "clamp(1.8rem,1.8rem, 1.8rem)",
        height: "clamp(1.8rem,1.8rem, 1.8rem)",
        borderRadius: ".4rem",
        fontSize: "0.8rem",
        cursor: "pointer",
      }}>
      {getCount()}
    </Box>
  );
}

export default PendingCount;
